import React from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { Button, FormLabel, Textarea } from '@offerzen/pinata'
import { useSelector } from 'react-redux'

import ControlledHookField from '@/CandidateExperience/components/ControlledHookField'
import { userRole } from '@/CandidateExperience/selectors/currentUser'
import { UserRole } from '@/CandidateExperience/helpers/constants'

import styles from './styles'

const ApplyForm = ({ handleApply, companyName, messageFieldDescription }) => {
  const { control, handleSubmit } = useForm()
  const loggedInUserRole = useSelector(userRole)

  return (
    <form onSubmit={handleSubmit(handleApply)}>
      <FormLabel label="Message" htmlFor="message" optional />
      <ControlledHookField
        id="message"
        name="message"
        control={control}
        component={Textarea}
        className={styles.textarea}
        placeholder={`Let ${companyName} know why you're interested.`}
        disabled={loggedInUserRole === UserRole.Admin}
        ariaDescribedby="message-input-description"
        autosize
      />
      <div id="message-input-description">{messageFieldDescription}</div>

      <Button label="Apply" size="medium" type="submit" className={styles.button} disabled={loggedInUserRole === UserRole.Admin} />
    </form>
  )
}

ApplyForm.propTypes = {
  messageFieldDescription: PropTypes.node.isRequired,
  handleApply: PropTypes.func.isRequired,
  companyName: PropTypes.string.isRequired,
}

export default ApplyForm
